import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { DevFlag, injectDevFlag } from '@recruitee/dev-flags-data';
import {
  WorkModelSectionComponent,
  WorkModelSectionMode,
  WorkModelSectionTranslations,
  WorkModelSectionTranslationsToken,
  WorkModelSectionViewContext,
} from '@recruitee/locations';

import { RequisitionForm } from '../../../requisitions.types';

const translations: WorkModelSectionTranslations = {
  heading: 'app.requisitions.details_page.work_model.heading',
  subheading: 'app.requisitions.details_page.work_model.subheading',
};

@Component({
  standalone: true,
  selector: 'rt-requisitions-work-model',
  templateUrl: './requisitions-work-model.component.html',
  styleUrls: ['./requisitions-work-model.component.less'],
  imports: [WorkModelSectionComponent],
  providers: [{ provide: WorkModelSectionTranslationsToken, useValue: translations }],
})
export class RequisitionsWorkModelComponent {
  public readonly WorkModelSectionViewContext = WorkModelSectionViewContext;
  public readonly WorkModelSectionMode = WorkModelSectionMode;

  @Input() public isFormEditable: boolean;
  @Input() public form: FormGroup<RequisitionForm>;

  public hasNewJobEditor = injectDevFlag(DevFlag.NewJobEditor);

  public get workModelControl() {
    return <FormGroup>this.form.get('workModel')!;
  }
}
